import React, { Component } from 'react';
import { Col, Input, Row, Table } from 'reactstrap';
import Units from './Units/Units';
import axiosInstance from '@src/axios-instance';
import Auth from '@src/components/Elements/Auth/Auth';
import isAllowed from '@src/auth';
import ProgressBox from '@components/ProgressBox/ProgressBox';

class Addresses extends Component {
  constructor(props) {
    super(props);
    this.toggleInput = this.toggleInput.bind(this);
    this.state = {
      current_phase: false,
      total_phase: false,
      currentSave: false,
      loading: false,
      units: {
        loaded: false,
        list: [],
        total: 0,
        page: 1,
        limit: 10,
        start: 0,
        end: 10,
        sort: null,
        direction: null,
        phraze: ''
      }
    };
  }

  getList = getData => {
    this.setState({
      loading: true
    });
    getData.association_id = this.props.entity.id;
    axiosInstance()
      .get('/units.json', { params: getData })
      .then(response => {
        this.setState({
          units: { ...response.data, loaded: true },
          loading: false
        });
      })
      .catch(err => {});
  };

  toggleInput(input) {
    if (isAllowed({ action: 'Associations::editDetails' })) {
      const current = this.state[input];
      this.setState({
        [input]: !current
      });
      if (!current) {
        setTimeout(() => {
          document.getElementsByClassName('current-phase')[0].focus();
        }, 200);
      }
    }
  }

  onSubmit = (e, name) => {
    const postData = {
      [name]: e.currentTarget.value
    };
    this.props.onSubmit(this.props.entity.id, postData);
    const current = this.state[name];
    this.setState({
      [name]: !current,
      currentSave: name
    });
  };

  render = () => {
    const { entity } = this.props;
    return (
      <React.Fragment>
        {this.state.loading && (
          <ProgressBox text={'Loading ...'} loader={'transparent-background'} />
        )}
        <Row>
          <Col xs={12}>
            <Table className={'table-blue'} size={'lg'}>
              <tbody>
                <tr className={'border-left border-right border-bottom'}>
                  <td className={'color-blue w-25'}>Current Phase</td>
                  <td className={'text-right color-blue border-right w-25'}>
                    {!this.state.current_phase ? (
                      this.props.loading &&
                      this.state.currentSave === 'current_phase' ? (
                        <span>Saving...</span>
                      ) : (
                        <span
                          onClick={() => this.toggleInput('current_phase')}
                          className={'pointer d-block'}
                        >
                          &nbsp;
                          {entity.current_phase === null
                            ? '---'
                            : entity.current_phase}
                        </span>
                      )
                    ) : (
                      <Auth action={'Associations::editDetails'}>
                        <Input
                          className={
                            'text-right my-0 py-0 color-blue current-phase h-auto'
                          }
                          defaultValue={entity.current_phase}
                          type={'number'}
                          onBlur={e => this.onSubmit(e, 'current_phase')}
                        />
                      </Auth>
                    )}
                  </td>
                  <td className={'color-blue w-25'}>Total Phases</td>
                  <td className={'text-right color-blue w-25'}>
                    {!this.state.total_phase ? (
                      this.props.loading &&
                      this.state.currentSave === 'total_phase' ? (
                        <span>Saving...</span>
                      ) : (
                        <span
                          onClick={() => this.toggleInput('total_phase')}
                          className={'pointer d-block'}
                        >
                          &nbsp;
                          {entity.total_phase === null
                            ? '---'
                            : entity.total_phase}
                        </span>
                      )
                    ) : (
                      <Auth action={'Associations::editDetails'}>
                        <Input
                          className={
                            'text-right my-0 py-0 color-blue current-phase h-auto'
                          }
                          defaultValue={entity.total_phase}
                          type={'number'}
                          onBlur={e => this.onSubmit(e, 'total_phase')}
                        />
                      </Auth>
                    )}
                  </td>
                </tr>
              </tbody>
            </Table>
            <Table className={'table-blue'} size={'lg'}>
              <tbody>
                <tr className={'border-left border-right border-bottom'}>
                  <td className={'color-blue w-25'}>Units Listed</td>
                  <td className={'text-right color-blue w-25 border-right'}>
                    {this.state.units.total}
                  </td>
                  <td className={'color-blue w-25'}>
                    Total Units in Association
                  </td>
                  <td className={'text-right color-blue w-25'}>
                    {!this.state.total_units ? (
                      this.props.loading &&
                      this.state.currentSave === 'total_units' ? (
                        <span>Saving...</span>
                      ) : (
                        <span
                          onClick={() => this.toggleInput('total_units')}
                          className={'pointer d-block'}
                        >
                          &nbsp;
                          {entity.total_units === null
                            ? '---'
                            : entity.total_units}
                        </span>
                      )
                    ) : (
                      <Auth action={'Associations::editDetails'}>
                        <Input
                          className={
                            'text-right my-0 py-0 color-blue current-phase h-auto'
                          }
                          defaultValue={entity.total_units}
                          type={'number'}
                          onBlur={e => this.onSubmit(e, 'total_units')}
                        />
                      </Auth>
                    )}
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>

        <Units entity={entity} getList={this.getList} {...this.state.units} />
      </React.Fragment>
    );
  };
}
export default Addresses;
